var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvailability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 212836486"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 9",
    opacity: 0.26,
    cx: 22,
    cy: 22,
    r: 22,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.4844 32.4844C16.4091 32.4844 11.4844 27.5597 11.4844 21.4844C11.4844 15.4091 16.4091 10.4844 22.4844 10.4844C28.5597 10.4844 33.4844 15.4091 33.4844 21.4844C33.4844 27.5597 28.5597 32.4844 22.4844 32.4844ZM22.4844 30.2844C24.8183 30.2844 27.0566 29.3572 28.7069 27.7069C30.3572 26.0566 31.2844 23.8183 31.2844 21.4844C31.2844 19.1505 30.3572 16.9122 28.7069 15.2618C27.0566 13.6115 24.8183 12.6844 22.4844 12.6844C20.1505 12.6844 17.9122 13.6115 16.2618 15.2618C14.6115 16.9122 13.6844 19.1505 13.6844 21.4844C13.6844 23.8183 14.6115 26.0566 16.2618 27.7069C17.9122 29.3572 20.1505 30.2844 22.4844 30.2844ZM23.5844 21.4844H27.9844V23.6844H21.3844V15.9844H23.5844V21.4844Z",
    fill: "#CCAD63"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailability);
export default __webpack_public_path__ + "static/media/availability.30269e3fbbd4359bb1018829dda73577.svg";
export { ForwardRef as ReactComponent };